import { useEffect, useState } from 'react';

const css = {
  filterItem: {listStyle: 'none', cursor: 'pointer', padding: '5px'},
  selectedItem: {listStyle: 'none', cursor: 'pointer', padding: '5px', fontWeight: 'bold'}
}

const HistoryFilterItem = (props) => {
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(props.filter.filterSelected);
  }, [props.filter.filterSelected]);

  const handleFilter = (e) => {
    props.onSelected(e.target.getAttribute('statustarget'));
    setSelected(!selected);
  }

  return (
    <li
      onClick={handleFilter}
      statustarget={props.filter.statusTarget}
      style={selected ? css.selectedItem : css.filterItem}
    >
      {props.filter.name}
    </li>
  );
}

export default HistoryFilterItem;